<template>
  <applySelectModal :value='capacityEditStatus'>
    <div name='slot'>
      <h1>Capacity</h1>
      <p class='capacity-edit-title'>How many mentees would you like to take on？</p>
      <div style="margin-bottom: 20px;color: #ababab;">Notes: 2022 means the mentee is applying for 2022 fall enrollment,
        therefore you will help the mentees mostly in 2021 fall. Please ignore the capacity modification of 2020 and 2021.
      </div>
      <div v-if="userRole === 'SM' || userRole === 'CM'">
        <Form ref="formValidateSMCM" :model="formValidateSMCM" class='apply-capacity-modal'>
          <div class="apply-capacity-select" v-for='(item, index) in info.capacityInfo.capacityInfos' :key='index'>
            <FormItem :label="`${item.year}`" :prop='`capacityInfos.${index}`'
              :rules="{ required: item.year > currentYear, message: promptSelect }">
              <Cascader :data="menteeNumList" :disabled="item.year <= currentYear"
                @on-change="handleChange($event, index, item.year)" v-model="formValidateSMCM.capacityInfos[index]">
              </Cascader>
            </FormItem>
          </div>
        </Form>
      </div>
      <div v-if="userRole === 'EM'">
        <Form ref="formValidateEM" :model="formValidateEM" class='apply-capacity-modal'>
          <div class="apply-capacity-select" v-for='(item, index) in info.capacityInfo.capacityInfos' :key='index'>
            <FormItem :label="`${item.year}`" :prop='`capacityInfos.${index}`'
              :rules="{ required: true, message: promptSelect }">
              <Select v-model="formValidateEM.capacityInfos[index]" placeholder="Select" clearable>
                <Option :value="0">0</Option>
                <Option v-for="subItem in 50" :value='subItem' :key="subItem">{{ subItem }}</Option>
              </Select>
            </FormItem>
          </div>
        </Form>
      </div>
      <div class="apply-capacity-btn">
        <Button class="zlr-btn-primary" @click="subHandle" :loading="hasEditMore">Submit</Button>
        <Button class="zlr-btn-default" @click="closeHandle">Close</Button>
      </div>
    </div>
  </applySelectModal>
</template>

<script>
import applySelectModal from '@/components/modal/modal'
import { capacityEdit } from '@/api/talents'
import { promptSelect } from '@/constant'
export default {
  props: {
    status: {
      type: Boolean,
      default: false
    },
    userRole: {
      type: String
    },
    capacityInfos: {
      type: Object
    }
  },
  components: {
    applySelectModal
  },
  data() {
    return {
      // 校验提示信息
      promptSelect,
      menteeNumList: [
        {
          value: '1',
          label: '1 mentee'
        },
        {
          value: '2',
          label: '2 mentee'
        },
        {
          value: '3',
          label: '3 mentee'
        },
        {
          value: 'more',
          label: 'More than 3 mentees',
          children: [
            {
              value: '4',
              label: '4 mentee'
            },
            {
              value: '5',
              label: '5 mentee'
            },
            {
              value: '6',
              label: '6 mentee'
            },
            {
              value: '7',
              label: '7 mentee'
            },
            {
              value: '8',
              label: '8 mentee'
            },
            {
              value: '9',
              label: '9 mentee'
            },
            {
              value: '10',
              label: '10 mentee'
            }
          ]
        }
      ],
      capacityEditStatus: false,
      currentYear: 0,
      formValidateSMCM: {
        capacityInfos: []
      },
      info: {
        capacityInfo: {
          capacityInfos: []
        },
        paymentInfo: {
          paymentInfo: {},
          otherInfo: {}
        },
      },
      oldFormValidateSMCM: {
        capacityInfos: []
      },
      // loading 状态
      hasEditMore: false,
    }
  },
  methods: {
    // capacity Edit api
    submitEdit(capacity) {
      // 调用接口
      capacityEdit({ capacity: capacity }).then(res => {
        this.hasEditMore = false
        this.editMoreModal = false
        this.capacityEditStatus = false
        this.$emit('success', true)
        
      }).catch(error => {
        this.hasEditMore = false
        this.$zlr_message(error.message, 'error')
      })
    },
    subHandle() {
      // 根据角色赋值
      let capacityInfos = []
      if (this.userRole === 'SM' || this.userRole === 'CM') {
        this.$refs.formValidateSMCM.validate((valid) => {
          if (valid) {
            let smallNum = []
            this.formValidateSMCM.capacityInfos.forEach((item, index) => {
              let itemNumber = Number(item[item.length - 1])
              let oldItemNumber = Number(this.oldFormValidateSMCM.capacityInfos[index][this.oldFormValidateSMCM.capacityInfos[index].length - 1])
              let year = this.info.capacityInfo.capacityInfos[index].year
              if (itemNumber < oldItemNumber) {
                this.$zlr_message(year + ':You cannot select a value smaller than the current option')
                smallNum.push(item)
              }
            })
            if (smallNum.length === 0) {
              this.hasEditMore = true
              this.formValidateSMCM.capacityInfos.map((item, index) => {
                capacityInfos.push({
                  year: this.info.capacityInfo.capacityInfos[index].year,
                  count: Number(item[item.length - 1])
                })
              })
              // 调用接口
              this.submitEdit(capacityInfos)
            }
          }
        })
      }
      if (this.userRole === 'EM') {
        this.$refs.formValidateEM.validate((valid) => {
          if (valid) {
            this.hasEditMore = true
            this.formValidateEM.capacityInfos.map((item, index) => {
              capacityInfos.push({
                year: this.info.capacityInfo.capacityInfos[index].year,
                count: Number(item)
              })
            })
            // 调用接口
            this.submitEdit(capacityInfos)
          }
        })
      }
    },
    closeHandle () {
      this.capacityEditStatus = false
      this.$emit('success', false)
    },
    handleChange (event, index, year) {
      let changeVal = event[event.length - 1]
      let oldValLength = this.oldFormValidateSMCM.capacityInfos[index].length
      let oldVal = this.oldFormValidateSMCM.capacityInfos[index]
      if (oldVal && oldVal.length > 0) {
        if (Number(changeVal) < Number(oldVal[oldValLength - 1])) {
          this.$zlr_message(year + ':You cannot select a value smaller than the current option')
          return false
        } else {
          this.formValidateSMCM.capacityInfos[index] = event
        }
      } else {
        this.formValidateSMCM.capacityInfos[index] = event
      }
    },
    initInfo () {
      let temp = []
      let oldTemp = []
      // 根据角色赋值
      if (this.userRole === 'SM' || this.userRole === 'CM') {
        this.info.capacityInfo.capacityInfos.map(item => {
          if (item.count && item.count > 3) {
            temp.push(['more', String(item.count)])
            oldTemp.push(['more', String(item.count)])
          } else {
            temp.push(item.count ? [String(item.count)] : [])
            oldTemp.push(item.count ? [String(item.count)] : [])
          }
          return item
        })
        this.formValidateSMCM.capacityInfos = temp
        this.oldFormValidateSMCM.capacityInfos = oldTemp
      }
      if (this.userRole === 'EM') {
        this.info.capacityInfo.capacityInfos.map(item => {
          temp.push(item.count)
          return item
        })
        this.formValidateEM.capacityInfos = temp
      }
    }
  },
  mounted (){
    this.currentYear = +new Date().getFullYear()
  },
  watch: {
    status(now, old) {
      if(now) {
        this.capacityEditStatus = now
        this.info = this.capacityInfos
        this.initInfo()
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import './../personal/personal.less';
</style>